import { Message } from 'element-ui';
import Vue from 'vue';
import axios from 'axios';
import router from './router';
import {
  getToken,
  removeToken,
  removeUserName,
  removeTeacherInfo,
  removeUserId,
  removeUserImg,
  removeFirstSign,
  getRequestPath
} from '@/utils/teacherAuth.js';

const NODE_ENV = process.env.NODE_ENV;
const API_ROOT = process.env.API_ROOT;
const API_ROOT_HK = process.env.API_ROOT_HK;

function isHkDomain() {
  return window.location.hostname === 'hk.talk915.com';
}

function getBaseURL() {
  let baseURL = '';
  if (NODE_ENV === 'development') {
    const devRequestPath = getRequestPath();
    baseURL = devRequestPath ? devRequestPath : '/api';
  } else {
    if (isHkDomain()) {
      baseURL = API_ROOT_HK;
    } else {
      baseURL = API_ROOT;
    }
  }
  return baseURL;
}

const http = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? 'http://10.204.42.62:9091' : process.env.BASE_API,
  // baseURL:process.env.API_ROOT,
  timeout: 600000,
  withCredentials: true
});

//请求超时重新请求次数，请求间隙
// axios.defaults.retry = 3;
// axios.defaults.retryDelay = 1000;

// 请求拦截
http.interceptors.request.use(
  config => {
    config.baseURL = getBaseURL();
    if (typeof getToken() !== 'undefined') {
      config.headers['token'] = getToken();
    }
    return config;
  },
  err => {
    return Promise.reject(error);
  }
);

//响应拦截
http.interceptors.response.use(
  response => {
    if (
      response.data &&
      response.data.resultCode !== 0 &&
      response.data.resultMessage
    ) {
      if (response.data.resultCode === 3) {
        if (response.config.hideMessage) {
          return Promise.reject(response.data || 'Error');
        } else {
          Vue.prototype.$message({
            type: 'error',
            message: response.data.resultMessage
          });
        }
      } else if (response.data.resultCode === -1) {
        Vue.prototype.$message({
          type: 'error',
          message: response.data.resultMessage
        });
        removeToken();
        removeUserName();
        removeTeacherInfo();
        removeUserId();
        removeUserImg();
        removeFirstSign();
        router.push({
          name: 'Login'
        });
      } else {
        Vue.prototype.$message({
          type: 'error',
          message: `操作异常，请联系管理员（${response.data.resultCode}）!`
        });
      }
      return Promise.reject(response || 'Error');
    }
    return response;
  },
  err => {
    //请求超时，设置重新请求及错误提示
    // let config = err.config;
    // loadingInstance.close();
    // if (!config ) {
    Vue.prototype.$message({
      type: 'error',
      message: (err && err.data && err.data.msg) || '服务繁忙'
    });
    return Promise.reject(err);
    // }
    //设置请求超时次数
    // config.__retryCount = config.__retryCount || 0;
    // if (config.__retryCount >= config.retry) {
    //   Vue.prototype.$message({
    //     type:'error',
    //     message:(err && err.data && err.data.msg) || '服务繁忙',
    //   });
    //   return Promise.reject(err);
    // }
    // config.__retryCount += 1;
    // let backoff = new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve();
    //   }, config.retryDelay || 1);
    // });
    // return backoff.then(() => {
    //   return service(config);
    // });
  }
);

/**
 * formData数据转换
 * @param {*} params 参数对象
 */
http.formData = (data = {}) => {
  var bodyFormData = new FormData();
  var keys = Object.keys(data);
  var vals = Object.values(data);
  for (let i = 0; i < Object.keys(data).length; i++) {
    bodyFormData.set(keys[i], vals[i]);
  }
  // bodyFormData.set('t', new Date().getTime());
  return bodyFormData;
};

export default http;



// WEBPACK FOOTER //
// ./src/config/axios.js